import api, { apiSetup } from '../api';

apiSetup();

export class EstadosService {
  BASE_URL = '/estados';

  get() {
    return api.get(this.BASE_URL);
  }
}
